import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import { useContext } from 'react';
import { CKEditorContext } from 'contexts';

export const useCKEditor = (): Editor => {
  const context = useContext(CKEditorContext);

  if (!context) {
    throw new Error('CKEditor instance is unavailable');
  }

  return context;
};
